"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledInput = (0, material_1.styled)(material_1.Input, {
  shouldForwardProp: prop => prop !== "fontSize" && prop !== "alwaysUnderline"
})(({
  fontSize,
  alwaysUnderline
}) => ({
  [`&.${material_1.inputClasses.root}`]: {
    minHeight: 32,
    fontSize: fontSize
  },
  [`&.${material_1.inputClasses.underline}`]: alwaysUnderline ? {} : {
    "&:before": {
      borderBottom: "0px solid transparent"
    }
  }
}));

const SskyInputField = props => {
  const inputProps = {
    maxLength: props.maxLength
  };
  return react_1.default.createElement(StyledInput, {
    id: props.id,
    value: props.value,
    defaultValue: props.defaultValue,
    fullWidth: props.fullWidth,
    placeholder: props.placeholder,
    disabled: props.disabled,
    autoFocus: props.autoFocus,
    error: props.error,
    multiline: props.multiline,
    rows: props.rows,
    maxRows: props.rowsMax,
    type: props.type,
    onChange: props.onChange,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onKeyDown: props.onKeyDown,
    onKeyUp: props.onKeyUp,
    inputProps: inputProps,
    inputRef: props.inputRef,
    startAdornment: props.startAdornment && react_1.default.createElement(material_1.InputAdornment, {
      position: "start"
    }, props.startAdornment),
    endAdornment: props.endAdornment && react_1.default.createElement(material_1.InputAdornment, {
      position: "end"
    }, props.endAdornment),
    "data-testid": props.dataTestId || `testId-${props.id}`,
    alwaysUnderline: props.alwaysUnderline
  });
};

SskyInputField.defaultProps = {
  alwaysUnderline: true,
  error: false,
  fontSize: 16,
  fullWidth: false,
  multiline: false
};
exports.default = react_1.default.memo(SskyInputField);